import React, { useEffect, useState } from "react";
import NewsDetails from "./NewsDetails";
import { useParams } from "react-router-dom";
import { UserDropdown } from "../../Shared/UserDropdown";
import { httpPost } from "../../../utility/requestHelper";
import { envConfig } from "../../../constants/api-endpoint";
import { getCookie, setCookie } from "../../../utility/cookieProvider";
import {
  COOKIE,
  DATE_FORMATS,
  MEDIA_TYPES,
} from "../../../constants/app-constant";
import Loader from "../../Shared/Loader";
import { formatDate, isLoggedIn } from "../../../utility/common-methods";
import {
  ShareIcon,
  FavoriteIcon,
  MenuIcon,
} from "../../../components/Icons/icons.component";
import ConceptLogo from "../../../assets/images/conceptbiu-logo.png";
import { isAuthenticated } from "../../../actions/client-action";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { FEED_DETAILS_ALL } from "../../../constants/route-constants";
const { PRINT_DETAILS, ONLINE_DETAILS } = envConfig;

export default function NewsDetailsMain() {
  const { articleIdentifier, mediaType } = useParams();
  const [details, setDetails] = useState({});
  const [clientDetails, setClientDetails] = useState({});
  const [showError, setShowError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID) || null;
  const paramsToken = articleIdentifier.split("-");
  const clientId = paramsToken[0];
  const articleId = paramsToken[1];
  const entityId = paramsToken[2];
  const [publicationLogo, setPublicationLogo] = useState(null);
  const dispatch = useDispatch();
  const clientState = useSelector((state) => state.clientReducer) || {};
  const { isAuth } = clientState;
  const history = useHistory();
  useEffect(() => {
    setIsLoading(true);
    if (!isLoggedIn()) {
      dispatch(isAuthenticated());
    }
  }, []);

  useEffect(() => {
    const url =
      mediaType == MEDIA_TYPES.PRINT_MV ? PRINT_DETAILS : ONLINE_DETAILS;
    setIsLoading(true);
    setDetails({});
    httpPost(
      url,
      {
        client_id: clientId,
        article_id: articleId,
        entity_id: entityId,
        user_id: concept_uid,
        rbase_url: "cbiu.weboapps.com",
      },
      {
        Unauthorization: true,
      }
    )
      .then(
        ({
          data: {
            result: {
              article = {},
              circlation = "",
              ccm_val,
              mav_val,
              images = [],
              opoint_details = {},
              similar_web_details = {},
              client_detail,
              sqcm_val,
              is_text_view,
              display_img_height,
              display_img_width,
              show_images_by_godrej_size,
              is_show_similar_web,
              alexa_details,
              entity_detail,
              updated_values,
              categories,
              tonality,
              other_edition_url_html,
              publication_logo,
              newsletter_article_url,
              traffic_estimate
            },
            messsage,
            status,
          },
        }) => {
          if (status == 200) {
            // Set client details returned from api
            setClientDetails(client_detail);
            // tranforming the data in format of search api response to make the details page have uniform params
            setDetails({
              opoint_details,
              ...similar_web_details,
              ...article,
              circlation,
              showImages: images.length,
              images: images.map((i) => i.image_url).join(","),
              CONTENT: article.content,
              hide_metadata_details: client_detail.hide_metadata_details,
              show_sqcm_pdf: client_detail.show_sqcm_pdf,
              sqcm_val,
              is_text_view,
              show_images_by_godrej_size,
              is_show_similar_web,
              alexa_details,
              entity_detail,
              client_detail,
              updated_values,
              tonalities: tonality,
              categories,
              other_edition_url_html,
              ccm: ccm_val,
              mav: mav_val,
              publication_logo,
              height: images.map((i) => i.display_img_height),
              width: images.map((i) => i.display_img_width),
              newsletter_article_url,
              monthly_visitor: traffic_estimate
            });
            setPublicationLogo(publication_logo);
          } else {
            setShowError(messsage || "Article not found");
          }
        }
      )
      .catch((e) => setShowError("Article not found"))
      .finally(() => setIsLoading(false));
  }, [articleIdentifier]);

  const {
    category,
    edition_id,
    headline,
    press_release,
    publication_id,
    publication_type,
    publication_type_id,
    source,
    reporter,
    tonality,
    publish_datetime,
    publication_logo,
    id,
  } = details;

  const entity = entityId ? +entityId : parseInt(clientId, 10);

  const downloadParams = {
    category,
    client_id: clientId,
    clientName: clientDetails.client_name,
    edition_id,
    end_date: formatDate(
      new Date(publish_datetime),
      DATE_FORMATS.YYYYMMDD_slash
    ),
    start_date: formatDate(
      new Date(publish_datetime),
      DATE_FORMATS.YYYYMMDD_slash
    ),
    entities: [entity],
    headline,
    keywords: "",
    press_release,
    publication_id,
    publication_type,
    source_type: source,
    reporter,
    tonality,
    zone: "",
    print_article_ids: mediaType === MEDIA_TYPES.PRINT_MV ? [id] : [],
    online_article_ids: mediaType === MEDIA_TYPES.ONLINE_MV ? [id] : [],
    media_type:
      mediaType === MEDIA_TYPES.ONLINE_MV
        ? MEDIA_TYPES.ONLINE
        : MEDIA_TYPES.PRINT,
  };
  const { message, result } = isAuth;
  return (
    <>
      {isLoggedIn() ? (
        <div className="mainContainer newsDetailsContainer">
          {isLoading && (
            <div style={{ marginTop: "15%", position: "relative" }}>
              {" "}
              <Loader />
            </div>
          )}
          <div className="dashboardHeader">
            <div className="dashboardHeaderTop d-flex">
              <div className="dashboardMobileMenu">
                <button className="btn menuBtn" id="menuBtn">
                  <MenuIcon />
                </button>
                <img src={ConceptLogo} width="32" height="32" />
              </div>
            </div>
          </div>
          {!isLoading && details.id && (
            <NewsDetails
              selectedArticle={details || {}}
              isPrint={mediaType == MEDIA_TYPES.PRINT_MV}
              isOnline={mediaType == MEDIA_TYPES.ONLINE_MV}
              clientId={clientId}
              isNewsDetailsMain
              downloadParams={downloadParams}
              publication_type_id={publication_type_id}
            />
          )}
          {showError && <div className="404article">{showError}</div>}
        </div>
      ) : result ? (
        <div className="mainContainer newsDetailsContainer">
          {isLoading && (
            <div style={{ marginTop: "15%", position: "relative" }}>
              {" "}
              <Loader />
            </div>
          )}
          <div className="dashboardHeader">
            <div className="dashboardHeaderTop d-flex">
              <div className="dashboardMobileMenu">
                <button className="btn menuBtn" id="menuBtn">
                  <MenuIcon />
                </button>
                <img src={ConceptLogo} width="32" height="32" />
              </div>
            </div>
          </div>
          {!isLoading && details.id && (
            <NewsDetails
              selectedArticle={details || {}}
              isPrint={mediaType == MEDIA_TYPES.PRINT_MV}
              isOnline={mediaType == MEDIA_TYPES.ONLINE_MV}
              clientId={clientId}
              isNewsDetailsMain
              downloadParams={downloadParams}
              publication_type_id={publication_type_id}
            />
          )}
          {showError && <div className="404article">{showError}</div>}
        </div>
      ) : (
        <div className="personalDetailsWrap">
          <div className="fulwidth mt0">
            <p>{message}</p>
            <button
              className="border-btn btn primary-btn"
              onClick={() => {
                history.push("/");
              }}
            >
              Ok
            </button>
          </div>
        </div>
      )}
    </>
  );
}
